import React from 'react';
import './styles.less';

const TnIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">тн</span>
	</i>
);

const KgIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">кг</span>
	</i>
);

const VolumeIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">м³</span>
	</i>
);

const PieceIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">шт</span>
	</i>
);

const PriceIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">руб</span>
	</i>
);

const SizeTextIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">см</span>
	</i>
);

const PercentIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">%</span>
	</i>
);

const GradusIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">°C</span>
	</i>
);

const EmptyIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text" />
	</i>
);

const HourIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">ч</span>
	</i>
);

const MinuteIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">мин</span>
	</i>
);

const KmIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">км</span>
	</i>
);

const LiterIcon = (
	<i className="text-icon">
		<span className="text-icon input-group-text">л</span>
	</i>
);

export {
	TnIcon,
	KgIcon,
	VolumeIcon,
	PieceIcon,
	PriceIcon,
	SizeTextIcon,
	PercentIcon,
	GradusIcon,
	EmptyIcon,
	HourIcon,
	MinuteIcon,
	KmIcon,
	LiterIcon,
};
